/**
 * Support and guidance links — compact help row on the dashboard.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { helpSectionHref } from '../../content/helpGuidesContent';

const LINKS = [
  { label: 'Help & Guides', to: '/help', testId: 'support-help-guides' },
  { label: 'Recording tips', to: helpSectionHref('voice-recording'), testId: 'support-recording-tips' },
  { label: 'Legacy Book guide', to: helpSectionHref('legacy-book'), testId: 'support-legacy-book-guide' },
  { label: 'Keepsake request help', to: helpSectionHref('keepsakes'), testId: 'support-keepsake-help' },
  { label: 'Family Gathering Room', to: helpSectionHref('family-gathering-room'), testId: 'support-gathering-room' },
];

export function DashboardSupportGuidanceSection() {
  return (
    <section
      className="rounded-2xl border border-[hsl(38_16%_82%)]/60 bg-[#fffdf8]/70 px-5 py-4 sm:px-6"
      data-testid="dashboard-support-guidance"
      aria-labelledby="support-guidance-heading"
    >
      <h2 id="support-guidance-heading" className="font-serif text-base font-light text-[#1c1917] sm:text-lg">
        Support &amp; guidance
      </h2>
      <ul className="mt-3 flex flex-wrap gap-x-4 gap-y-2">
        {LINKS.map((link) => (
          <li key={link.testId}>
            <Link
              to={link.to}
              className="text-sm text-[#5c534a] underline decoration-[#c9a961]/35 underline-offset-4 transition hover:text-[#1c1917]"
              data-testid={link.testId}
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export default DashboardSupportGuidanceSection;
